export default "__VITE_ASSET__DV$yIXTl__"